import useTranslation from '../hooks/useTranslation'
import Container from '../UI/Container/Container'

function LandingFooter() {
  const t = useTranslation()
  const f = t.landing.footer
  return (
    <div>
      <div className="border-t border-blue">
        <Container>
          <div className="py-5 flex flex-col md:flex-row md:items-center">
            <p className="font-bold text-blue md:w-1/3">{f.companyName}</p>
            <p className="text-blue md:text-right">{f.address}</p>
          </div>
        </Container>
      </div>

      <div className="border-t border-blue">
        <Container>
          <div className="py-5 flex flex-col md:flex-row md:items-center">
            <p className="font-bold text-blue md:w-1/3">{f.contactLabel}</p>
            <div className="flex flex-col md:flex-row flex-wrap md:items-center gap-x-6 gap-y-1 md:gap-x-8">
              <a href={f.phoneHref} className="text-blue hover:underline">
                {f.phone}
              </a>
              <a href={f.emailHref} className="text-blue hover:underline">
                {f.email}
              </a>
              <a href={f.instagramHref} target="_blank" rel="noopener noreferrer" className="text-blue hover:underline">
                {f.instagram}
              </a>
              <a href={f.linkedInHref} target="_blank" rel="noopener noreferrer" className="text-blue hover:underline">
                {f.linkedIn}
              </a>
            </div>
          </div>
        </Container>
      </div>

      <div className="border-t border-blue">
        <Container>
          <div className="py-5 flex flex-col md:flex-row md:items-center">
            <p className="md:w-1/3">{f.copyright}</p>
            <div className="flex gap-6 md:gap-8">
              <a href={f.impressumHref} className="text-blue hover:underline" target="_blank" rel="noopener noreferrer">
                {f.impressum}
              </a>
              <a href={f.datenschutzHref} className="text-blue hover:underline" target="_blank" rel="noopener noreferrer">
                {f.datenschutz}
              </a>
            </div>
          </div>
        </Container>
      </div>
    </div>
  )
}

export default LandingFooter
